import * as React from "react";
const ArrowTop = (props) => (
  <svg
    width={12}
    height={7}
    viewBox="0 0 12 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 5.97656L5.95313 1.02344L10.9063 5.97656"
      stroke="#4B5155"
      strokeWidth={1.5}
      strokeLinejoin="round"
    />
  </svg>
);
export default ArrowTop;
